var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopUniversitiesSubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.81rem",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-up-regular",
    d: "M14.5,2.719A11.781,11.781,0,1,1,2.719,14.5,11.781,11.781,0,0,1,14.5,2.719ZM14.5,29A14.5,14.5,0,1,0,0,14.5,14.5,14.5,0,0,0,14.5,29ZM7.652,12.314A1.262,1.262,0,0,0,8.513,14.5h3.268v5.438a1.811,1.811,0,0,0,1.813,1.813h1.813a1.811,1.811,0,0,0,1.813-1.812V14.5h3.268a1.262,1.262,0,0,0,.861-2.186L15.282,6.655a1.136,1.136,0,0,0-1.563,0Z",
    fill: "#ed4c16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUniversitiesSubIcon);
export default __webpack_public_path__ + "static/media/top-universities-sub-icon.a353f4ef391a5e7535437fea56feb8c7.svg";
export { ForwardRef as ReactComponent };